import { Route } from '@angular/router';
import { authGuard } from '@ribera-web/auth-data-access';
import { Shell } from '@ribera-web/shared-ui';

export const appRoutes: Route[] = [
  {
    path: '',
    component: Shell,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboard',
        loadChildren: () =>
          import('@ribera-web/dashboard-feature').then(
            (m) => m.dashboardFeatureRoutes,
          ),
      },
      {
        path: 'ventas',
        loadChildren: () =>
          import('@ribera-web/ventas-feature').then(
            (m) => m.ventasFeatureRoutes,
          ),
      },
      {
        path: 'cocina',
        loadChildren: () =>
          import('@ribera-web/cocina-feature').then(
            (m) => m.cocinaFeatureRoutes,
          ),
      },
      {
        path: 'caja',
        loadChildren: () =>
          import('@ribera-web/caja-feature').then(
            (m) => m.cajaFeatureRoutes,
          ),
      },
      {
        path: 'promociones',
        loadChildren: () =>
          import('@ribera-web/promociones-feature').then(
            (m) => m.promocionesFeatureRoutes,
          ),
      },
      {
        path: 'ajustes',
        loadChildren: () =>
          import('@ribera-web/ajustes-feature').then(
            (m) => m.ajustesFeatureRoutes,
          ),
      },
      {
        path: 'productos',
        loadChildren: () =>
          import('@ribera-web/product-feature').then(
            (m) => m.productFeatureRoutes,
          ),
      },
      {
        path: 'clientes',
        loadChildren: () =>
          import('@ribera-web/clientes-feature').then(
            (m) => m.clientesFeatureRoutes,
          ),
      }
    ]
  },
  {
    path: 'login',
    loadChildren: () =>
      import('@ribera-web/login-feature').then((m) => m.loginFeatureRoutes),
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
];
